import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { environment } from '../environments/environment';

import { NgbNavModule, NgbAccordionModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { SharedModule } from './cyptolanding/shared/shared.module';

import { ExtrapagesModule } from './extrapages/extrapages.module';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initFirebaseBackend } from './authUtils';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { PrintCaseReportComponent } from './print-case-report/print-case-report.component';
import { PrintCaseAnnexIIReportComponent } from './print-case-annex-ii-report/print-case-annex-ii-report.component';
import { PrintCaseAnnexIIIReportComponent } from './print-case-annex-iii-report/print-case-annex-iii-report.component';
import { PrintCaseAnnexIVReportComponent } from './print-case-annex-iv-report/print-case-annex-iv-report.component';
import { PrintCaseAnnexVReportComponent } from './print-case-annex-v-report/print-case-annex-v-report.component';
import { PrintListOfCopyCasesComponent } from './print-list-of-copy-cases/print-list-of-copy-cases.component';
import { PrintCaseAnnexVIReportComponent } from './print-case-annex-v-i-report/print-case-annex-v-i-report.component';
import { PrintCaseAnnexIVReportTwoComponent } from './print-case-annex-iv-report-two/print-case-annex-iv-report-two.component';
import { PrintAnnexureVAToVDComponent } from './print-annexure-v-a-to-v-d/print-annexure-v-a-to-v-d.component';
import { PrintLetterComponent } from './print-letter/print-letter.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    CyptolandingComponent,
    PrintCaseReportComponent,
    PrintCaseAnnexIIReportComponent,
    PrintCaseAnnexIIIReportComponent,
    PrintCaseAnnexIVReportComponent,
    PrintCaseAnnexVReportComponent,
    PrintListOfCopyCasesComponent,
    PrintCaseAnnexVIReportComponent,
    PrintCaseAnnexIVReportTwoComponent,
    PrintAnnexureVAToVDComponent,
    PrintLetterComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    SharedModule,
    ScrollToModule.forRoot(),
    NgbModule,
    AgGridModule,
    BrowserModule ,
    CommonModule
  ],
  bootstrap: [AppComponent],
  providers: [
    // LoaderService,
    // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
  ],
})
export class AppModule { }
